<div class="page-layout carded left-sidenav toolbar-fixed-layout">
  <particle-breadcumb-tab-action *ngIf="viewType=='Compact'"
                                 [breadcrumbs]="breadcrumbs"
                                 [actions]="actions"
                                 (viewTypeChanged)="viewTypeChanged($event)"
  >
  </particle-breadcumb-tab-action>
  <div *ngIf="viewType!='Compact'" class="toolbar second-level-toolbar flex flex-row justify-between items-center">
    <div class="grid-toolbar-buttons-group-container w-p-100 flex flex-col justify-center items-start">
      <particle-breadcrumbs [breadcrumbs]="breadcrumbs"
                            (dropDownSelectionChanged)="onDropDownSelectionChanged($event)"></particle-breadcrumbs>
    </div>
    <div class="flex flex-row justify-start items-center">
      <div class="avatar-container flex flex-row justify-end items-center" *ngIf="formId">
        <particle-user-activity [endpoint]="endpointName" [sourceId]="formId"></particle-user-activity>
      </div>
      <button class="view-change m-l-20" (click)="compactViewType()">
        <i class="fas fa-expand-alt"></i>
      </button>
    </div>
  </div>
  <div *ngIf="viewType!=='Compact'" class="toolbar second-level-toolbar flex flex-row justify-between items-center">
    <div class="grid-toolbar-buttons-group-container flex flex-col justify-center items-start">
      <label class="component-label"> Actions</label>
      <div class="grid-toolbar-buttons-group flex flex-row justify-start items-center">

        <div class="button-container flex flex-row justify-start items-center">
          <button mat-button class="orbitax-flat-button" (click)="showExportFilingDialog()"
                  particleAnalytics
                  analyticsCategory="Export"
                  analyticsAction="Export"
          >Export
          </button>
          <div class="toolbar-separator"></div>
        </div>
        <div class="button-container m-l-10 flex flex-row justify-start items-center" *ngIf="showLanguageOption">
          <mat-slide-toggle [(ngModel)]="showOriginal" (change)="showOriginalChanged()">Original Language
          </mat-slide-toggle>
          <div class="toolbar-separator m-lr-10"></div>
        </div>
        <!--        <div class="button-container" fxLayout="row" fxLayoutAlign="start center">-->
        <!--          <mat-slide-toggle [(ngModel)]="autoSave" (change)="autoSaveChanged()" [disabled]="item && item.isReadOnly">Auto Save</mat-slide-toggle>-->
        <!--          <div class="toolbar-separator"></div>-->
        <!--        </div>-->
      </div>
    </div>

    <div class="grid-toolbar-buttons-group-container flex flex-col justify-center items-start">
      <div class="grid-toolbar-buttons-group-without-label flex flex-row justify-start items-center">
        <button mat-button class="start-data-survey m-r-10" (click)="save()"
                particleAnalytics
                analyticsCategory="Save"
                analyticsAction="Save"
                [disabled]="this.editedFields.length==0">
          <i class="fas fa-check"></i> Save Changes ({{this.editedFields?.length}})
        </button>
        <button mat-button class="start-data-survey m-r-10" (click)="startDataSurvey()"
                [disabled]="item && item.isReadOnly"><i class="fal fa-play"></i> Create Survey Template
        </button>
        <button mat-button class="export-transmit" (click)="exportAndTransmit()" [disabled]="item && item.isReadOnly"><i
          class="fal fa-download"></i> Export & Transmit
        </button>
      </div>
    </div>

  </div>

  <mat-sidenav-container>

    <!-- CENTER -->
    <div class="center">

      <!-- CONTENT CARD -->
      <div class="content-card mat-white-bg">
        <!-- CONTENT TOOLBAR -->
        <div [ngClass]="containerClass" class="flex flex-col full-grow-no-shrink-no-basis">
          <particle-dynamic-form-container class="particle-dynamic-form-container"
                                           *ngIf="sourceType && formField && item && fieldConfig && formFieldsValidationState && formFieldsErrorInformation"
                                           [formField]="formField"
                                           [formFieldsErrorInformation]="formFieldsErrorInformation"
                                           [formFieldsValidationState]="formFieldsValidationState"
                                           [fieldConfig]="fieldConfig"
                                           [sourceType]="sourceType"
                                           [endpointName]="endpointName"
                                           [item]="item"
                                           [showDelete]="showDelete"
                                           [invalidateSubject]="invalidateSubject"
                                           [showLanguageOption]="showLanguageOption"
                                           [editedFields]="editedFields"
                                           (valueChanged)="onValueChanged($event)"
                                           (fieldSelectionChange)="onFieldSelectionChanged($event)"
          >

          </particle-dynamic-form-container>

        </div>
      </div>
      <!-- / CONTENT CARD -->

    </div>
    <!-- / CENTER -->

  </mat-sidenav-container>

</div>
